import * as React from 'react';
import classNames from 'classnames';
import './Label.scss';

export interface IProps extends React.HTMLProps<HTMLLabelElement> {
  className?: string;
}

const Label = (props: IProps) => {
  const { className, ...labelProps } = props;

  return (
    <label 
      {...labelProps} 
      className={classNames('label', className)}
    />
  );
}

export default Label;



// WEBPACK FOOTER //
// ./src/components/FormElements/Label.tsx